import {Box} from "@mui/material"
import React, {useState} from "react"
import {useAppDispatch, useTypedSelector} from "../../store"
import {setAlertOpen} from "../../store/calendar/calendar.slice"
import {useCreateAppointmentTimesAddressMutation} from "../../store/rtk-api/appointment_times/appointment_times"
import {IAppDoctorTimesResult, ICreateAppTimesBody,} from "../../store/rtk-api/appointment_times/types"
import {convertDate, months} from "../common/helper"
import AppointmentWindow from "./AppointmentWindow"
import CalendarAppointmentsList from "./CalendarAppointmentsList"
import style from "./calendarList/CalendarList.module.css"
import {weekDaysName} from "./DaysList"

type Props = {
    ind: number
    doctor: IAppDoctorTimesResult
    portion: Date[]
}

const CalendarAppointment: React.FC<Props> = ({doctor, portion}) => {
    const {addressId} = useTypedSelector((state) => state.header)
    const dispatch = useAppDispatch()
    const [isOpen, setOpen] = useState(false)
    const [myDate, setMyDate] = useState<any[]>([])
    const [dateInfo, setDateInfo] = useState<string>("")
    const [
        createDoctorAppTime,
        {
            isLoading: createTimeLoading,
            isError: createTimeError,
            isSuccess: createTimeSuccess,
        },
    ] = useCreateAppointmentTimesAddressMutation()


    const handleWindowOpen = (date: any) => {
        setMyDate([
            `${weekDaysName[date.getDay()]}.`,
            `${date.getDate()}`,
            months[date.getMonth()],
        ])
        setOpen(true)
        // setDateInfo(formatDate(date?.toLocaleDateString()))
        // setDateInfo(date?.toLocaleDateString().split('.').reverse().join('-'))
        setDateInfo(convertDate(date))
    }
    const handlePerform = (body: ICreateAppTimesBody) => {
        createDoctorAppTime(body)
        dispatch(setAlertOpen(true))
    }
    const closeWindow = () => {
        setOpen(false)
    }

    return (
        <>
            <Box className={style.days2}>
                {portion.map((day, ind) => {
                    return (
                        <div
                            key={ind}
                            style={{flexGrow: 1}}
                            onClick={() => handleWindowOpen(day)}
                        >
                            <CalendarAppointmentsList doctor={doctor} day={day}/>
                        </div>
                    )
                })}
            </Box>
            {isOpen && (
                <AppointmentWindow
                    isWindowOpen={isOpen}
                    closeWindow={closeWindow}
                    isLoading={createTimeLoading}
                    isError={createTimeError}
                    isSuccess={createTimeSuccess}
                    handlePerform={handlePerform}
                    mainTexts={[
                        doctor?.last_name,
                        `${doctor?.first_name.slice(0, 1)}.`,
                        `${doctor?.middle_name.slice(0, 1)}.`,
                    ]}
                    btnText={"Подтвердить"}
                    dateTexts={myDate}
                    dateInfo={dateInfo}
                    clinicAddressId={addressId}
                    doctorId={doctor.id}
                    doctor={doctor}
                />
            )}
        </>
    )
}

export default CalendarAppointment
